import React from 'react';
import { Typography, IconButton, ListItem, ListItemAvatar, ListItemText, Divider, AppBar, Card } from '@material-ui/core';
import SendIcon from '@material-ui/icons/Send';
import ZoomInIcon from '@material-ui/icons/ZoomIn';
import ZoomOutIcon from '@material-ui/icons/ZoomOut';
import List from '@material-ui/core/List';
import ThumbUpIcon from '@material-ui/icons/ThumbUp';

import ThumbUpAltOutlinedIcon from '@material-ui/icons/ThumbUpAltOutlined';
import { fade, makeStyles, withStyles } from '@material-ui/core/styles';
import Avatar from '@material-ui/core/Avatar';
import Badge from '@material-ui/core/Badge';
import Paper from '@material-ui/core/Paper';
import InputBase from '@material-ui/core/InputBase';
import MenuIcon from '@material-ui/icons/Menu';
import SearchIcon from '@material-ui/icons/Search';
import DirectionsIcon from '@material-ui/icons/Directions';
import { VisibilityRounded } from '@material-ui/icons';

import GroupIcon from '@material-ui/icons/Group';
import AddRoundedIcon from '@material-ui/icons/AddRounded';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import VerifiedUserIcon from '@material-ui/icons/VerifiedUser';
import { formatTime, isTheSameMinute } from '../../../../../../helpers/time.helper';
import { clientTypeConstants } from '../../../../../constants/clientType.constants';
import SystemLabel from '../../../../../../system/SystemLabel/SystemLabel';

const OnlineBadge = withStyles((theme) => ({
    badge: {
        backgroundColor: '#44b700',
        color: '#44b700',
        boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
        '&::after': {
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            borderRadius: '50%',
            animation: '$ripple 1.2s infinite ease-in-out',
            border: '1px solid currentColor',
            content: '""',
        },
    },
    '@keyframes ripple': {
        '0%': {
            transform: 'scale(.8)',
            opacity: 1,
        },
        '100%': {
            transform: 'scale(2.4)',
            opacity: 0,
        },
    },
}))(Badge);

const useStyles = makeStyles((theme) => ({
    grow: {
        flexGrow: 1,
    },
    menuButton: {
        marginRight: theme.spacing(2),
    },
    title: {
        display: 'none',
        [theme.breakpoints.up('sm')]: {
            display: 'block',
        },
    },
    search: {
        position: 'relative',
        backgroundColor: '#3a3b3c',
        borderRadius: 5,
        marginRight: theme.spacing(2),
        marginLeft: 10,
        marginRight: 10,
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            marginLeft: 0,
            marginLeft: 10,
            marginRight: 10,
            width: '100%',
        },
    },
    searchIcon: {
        padding: theme.spacing(0, 2),
        height: '100%',
        color: '#FFFFFF99',
        position: 'absolute',
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    inputRoot: {
        color: 'inherit',
    },
    inputInput: {
        padding: theme.spacing(1, 1, 1, 0),
        // vertical padding + font size from searchIcon
        paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
        transition: theme.transitions.create('width'),
        width: '100%',
        color: '#FFFFFF99',
        [theme.breakpoints.up('md')]: {
            width: '20ch',
        },
    },
    root: {
        padding: '2px 4px',
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        borderBottom: '1px solid gainsboro'
    },
    input: {
        marginLeft: theme.spacing(1),
        flex: 1,
    },
    iconButton: {
        padding: 10,
    },
    divider: {
        height: 28,
        margin: 4,
    },
    sectionDesktop: {
        display: 'none',
        [theme.breakpoints.up('md')]: {
            display: 'flex',
        },
    },
    sectionMobile: {
        display: 'flex',
        [theme.breakpoints.up('md')]: {
            display: 'none',
        },
    },
    online: {
        background: '#44b700'
    },
    offline: {
        background: 'orangered'
    },
}));



export default class ChatList extends React.Component {
    state = {
        filter: ''
    }
    renderConversations = () => {
        const { template, visible, eventId } = this.props;
        const { filter } = this.state;
        const { meetingList, orderList, chats, currentChat } = this.props;
        let clientList = meetingList.filter(cl => cl.type == clientTypeConstants.INTERACTION_MEETING)
        let filteredKeys = orderList.map(a => { return a.badgeNo });
        if (filter) {
            filteredKeys = orderList.filter((ia) => ia.name.toString().toLowerCase().includes(filter.toLowerCase())).map((a, i) => { return a.badgeNo });
        }
        return (
            <div style={{ width: '100%', height: '100%' }}>
                <div>
                    <CustomizedInputBase onInput={this.onFilter} />
                </div>

                <List className="jir-scroll dark-card" style={{ maxHeight: 'calc(96vh - 191px)', overflowY: 'auto', overflowX: 'hidden' }}>
                    {chats/* .filter(c => filteredKeys.includes(c.target)) */.map((c, i) => {

                        let targetProfile = orderList.find(o => o.badgeNo == c.target);

                        return <Card key={i} className="dark-card" style={{ padding: '0px 5px', margin: '5px 0px', marginLeft: '10px', boxShadow: 'none' }}>
                            <ListItem
                                className="chat-list-item-dark"
                                style={{ backgroundColor: this.props.currentChat && c.target == this.props.currentChat.target ? '#292929b5' : undefined, padding: '0px 30px' }}
                                alignItems="flex-start" onClick={() => this.props.selectChat(c.target)}>
                                {!c.seen /* && props.currentChat && c.target != props.currentChat.target.badgeNo */ ?
                                    <div className="notice-dot" />

                                    : null}
                                <ListItemAvatar>
                                    {clientList.find(cl => cl.clientKey == c.target) ? (
                                        <OnlineBadge
                                            anchorOrigin={{
                                                vertical: 'bottom',
                                                horizontal: 'right',
                                            }}
                                            overlap="circle"
                                            variant="dot" >
                                            <Avatar className="chat-avatar" />
                                        </OnlineBadge>
                                    ) : (
                                            c.target == `ALL` ?
                                                <Avatar className="chat-avatar" >
                                                    <GroupIcon />
                                                </Avatar> : (
                                                    c.target == `MODERATOR` ?
                                                        <Avatar className="chat-avatar" >
                                                            <VerifiedUserIcon />
                                                        </Avatar>
                                                        : < Avatar className="chat-avatar" />
                                                )

                                        )}
                                </ListItemAvatar>
                                <ListItemText
                                    primary={<Typography
                                        component="h4"
                                        variant="body2"
                                        className={'primary-text'}
                                        color="textPrimary"
                                    >
                                        {c.target != `ALL` && c.target != 'MODERATOR' ? (!targetProfile ? <SystemLabel name="Anonymous" /> : targetProfile.name) : (c.target != 'MODERATOR' ? <SystemLabel name="OpenChat" /> : <SystemLabel name="Moderator" />)}
                                    </Typography>}
                                    secondary={
                                        <Typography className={'secondary-text'}>
                                            {c.previewText == 'INIT' ?
                                                <SystemLabel name="StartWrite" />
                                                : (c.lastChange ?
                                                    <React.Fragment>
                                                        {c.previewPreFix && c.target != 'MODERATOR' ? <React.Fragment> <SystemLabel name={c.previewPreFix} />: </React.Fragment> : null}{" "}
                                                        {c.previewText.substring(0, 20)} • {formatTime(c.lastChange)}
                                                    </React.Fragment>
                                                    : null)}
                                        </Typography>
                                    }
                                />
                            </ListItem>
                        </Card>
                    })}
                </List>
            </div >
        )
    }
    onFilter = (filter) => {
        this.setState({ filter })
    }
    getClasses = () => {
        useStyles();
    }
    render() {
        return this.renderConversations();
    }
}

function StatusBadge({ name, online = false }) {
    const classes = useStyles();
    return online ? (
        <OnlineBadge
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
            }}
            overlap="circle"
            variant="dot" >
            <Avatar className="chat-avatar"   >
                {/*   {name} */}
            </Avatar>
        </OnlineBadge>
    ) : (
            <Avatar className="chat-avatar"   >
                {/*   {name} */}
            </Avatar>
        )
}
function CustomizedInputBase({ onInput }) {
    const classes = useStyles();
    return (
        <div className={classes.search} >
            <div className={classes.searchIcon}>
                <SearchIcon />
            </div>
            <InputBase
                onChange={(e) => onInput(e.target.value)}
                classes={{
                    root: classes.inputRoot,
                    input: classes.inputInput,
                }}
                inputProps={{ 'aria-label': 'search' }}
            />
        </div>
    )
}

